import axios from 'axios'
import store from '@/store'

const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	headers: {
		'X-Api-Key': process.env.VUE_APP_KEY
	},
	timeout: 5000
})

service.interceptors.request.use(
	config => {
		if (store.getters.token) {
			config.headers = Object.assign({}, config.headers, {
				'X-Session-Token': store.getters.token
			})
		}

		return config
	},
	error => Promise.reject(error)
)

service.interceptors.response.use(
	response => {
		if (response && response.status == 205) {
			store.commit('REMOVE_TOKEN')
			store.commit('SET_CONFIRMED', false)
		}

		return response
	},
	error => {
		if (error && error.response && error.response.status == 401) {
			store.commit('REMOVE_TOKEN')
			store.commit('SET_CONFIRMED', false)
		}

		return error
	}
)

export default service
